__turbopack_context__.v({
  "badge": "UrgencySignalBadge-module-scss-module__OqrzSa__badge",
});
